// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesBets } from '../../../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesBetslips } from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';

const getOutcomesFromProps = (_, { outcomes }) => outcomes;

export const makeSelectBetslipOptionRepeatBetButtonProps = createSelector(
  [selectEntitiesBets, selectEntitiesOutcomes, selectEntitiesBetslips, getOutcomesFromProps],
  (bets, outcomesEntity, betslips, outcomes) => {
    const formatedBets = [];
    outcomes.forEach((outcome) => {
      if (!outcome) {
        return;
      }

      if (!outcome) {
        return;
      }

      const { betId } = outcome;
      const bet = bets[betId];

      if (outcome.subOutcomes) {
        outcome.subOutcomes.forEach((subOutcome) => {
          const subBet = outcomesEntity[subOutcome];

          formatedBets.push({
            isAvailable: subBet?.available || false,
            oddId: subBet?.oddId,
            betId: subBet?.betId,
            matchId: bet?.matchId,
          });
        });
      } else {
        formatedBets.push({
          isAvailable: outcome?.available || false,
          oddId: outcome?.oddId,
          betId: outcome?.betId,
          matchId: bet?.matchId,
        });
      }
    });

    return {
      unavailableBetsCount: formatedBets.filter((bet) => !bet.isAvailable).length,
      bets: formatedBets,
    };
  },
);
